const ProgramTopFilter = (function () {
  const triggerElement = $(".js-program-search-layer .container");

  function init() {
    if ($(triggerElement).length === 0 || Global.debug.disableTopbar) {
      return;
    }
    ScrollTrigger.create({
      id: "sticky-filter",
      trigger: triggerElement,
      start: () => `bottom top`,
      endTrigger: $("body"),
      end: "bottom+=100 bottom",
      onToggle: (self) => {
        if (self.isActive) {
          $(".js-sticky-filter").addClass("is-active");
          $("body").addClass("has-sticky-top");
        } else {
          $(".js-sticky-filter").removeClass("is-active");
          $("body").removeClass("has-sticky-top");
        }
      },
    });
  }
  // Updating metrics on resize is automatically done by ScrollTrigger.

  return {
    init,
  };
})();
